var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-expansion-item',{attrs:{"expand-separator":"","default-opened":_vm.defaultOpened,"icon":_vm.icon,"label":_vm.label,"header-class":_vm.headerClass,"header-inset-level":_vm.headerInsetLevel}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }